<template>
  <div class="filter-box">
    <div class="filter-row">
      <div class="search-box">
        <input
          type="text"
          class="form-control"
          v-model="search"
          placeholder="Buscar por nome, email ou documento..."
          @keyup.enter="applyFilter"
        />
        <i class="bx bx-search-alt search-icon"></i>
      </div>

      <!-- Bluetooth Printer Status -->
      <!-- Sem v-if: a caixa aparece em qualquer aparelho. Antes só renderizava
           quando navigator.bluetooth existia, o que a escondia no mobile.
           Onde a API não existe, o connect() rejeita e o operador recebe a
           mensagem de erro em vez de a opção simplesmente não estar lá. -->
      <div class="bt-box">
        <div class="bt-status" :class="{ connected: btConnected }">
          <i class="bx bx-bluetooth"></i>
          <span v-if="btConnected" class="bt-label">{{ btDeviceName }}</span>
          <span v-else class="bt-label">Impressora desconectada</span>
        </div>
        <button
          v-if="!btConnected"
          type="button"
          class="btn-bt"
          @click="connectPrinter"
          :disabled="btConnecting"
        >
          <b-spinner small v-if="btConnecting"></b-spinner>
          <template v-else><i class="bx bx-link"></i> Conectar</template>
        </button>
        <button
          v-else
          type="button"
          class="btn-bt disconnect"
          @click="disconnectPrinter"
        >
          <i class="bx bx-x"></i> Desconectar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { successMessage, errorMessage } from '@/components/alertsMessages'
import bluetoothPrinter from '@/modules/storage/service/webBluetoothPrinter'

export default {
  name: 'index-filter',
  props: {
    onFilter: Function
  },
  data: function () {
    return {
      search: '',
      btConnecting: false
    }
  },
  computed: {
    btSupported: function () {
      return bluetoothPrinter.isSupported()
    },
    btConnected: function () {
      return bluetoothPrinter.isConnected()
    },
    btDeviceName: function () {
      return bluetoothPrinter.getDeviceName() || 'Impressora'
    }
  },
  methods: {
    applyFilter: function () {
      if (this.onFilter) {
        this.onFilter({ search: this.search })
      }
    },
    connectPrinter: function () {
      var self = this
      self.btConnecting = true
      bluetoothPrinter.connect()
        .then(function () {
          self.btConnecting = false
          self.$forceUpdate()
          successMessage('Impressora conectada: ' + bluetoothPrinter.getDeviceName())
        })
        .catch(function (err) {
          self.btConnecting = false
          errorMessage(err.message || 'Erro ao conectar impressora')
        })
    },
    disconnectPrinter: function () {
      bluetoothPrinter.disconnect()
      this.$forceUpdate()
    }
  },
  watch: {
    search: function (val) {
      var self = this
      clearTimeout(self.searchTimeout)
      self.searchTimeout = setTimeout(function () {
        self.applyFilter()
      }, 300)
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-box {
  background-color: #ffffff;
  border-radius: 5px;
  padding: 16px 20px;
  border: 1px solid rgba(233, 233, 233, 0.59);
}

.filter-row {
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 10px;

    .search-box {
      width: 100%;
    }

    .bt-box {
      width: 100%;
      justify-content: space-between;
    }
  }
}

.search-box {
  position: relative;
  flex: 1;

  .form-control {
    padding-left: 40px;
  }

  .search-icon {
    position: absolute;
    left: 13px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 18px;
    color: #74788d;
  }
}

.bt-box {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  flex-shrink: 0;
}

.bt-status {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #999;

  i {
    font-size: 18px;
  }

  .bt-label {
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
  }

  &.connected {
    color: #34c38f;
  }
}

.btn-bt {
  display: flex;
  align-items: center;
  gap: 4px;
  background: #556ee6;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 5px 12px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: #4a5fd4;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  &.disconnect {
    background: transparent;
    color: #dc3545;
    border: 1px solid #dc3545;
    padding: 4px 10px;

    &:hover {
      background: #dc3545;
      color: #fff;
    }
  }
}
</style>
